import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ChatInbox.css";
import { getUserConversations } from "../../utils/APIs/chatApis";
import Loader from "../../Template/Loader/Loader";
import { TfiArrowCircleLeft } from "react-icons/tfi";
import { FaUserCircle } from "react-icons/fa";

const ChatInbox = () => {
  const navigate = useNavigate();
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentUserId = localStorage.getItem("client_id");

  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const res = await getUserConversations();
        if (res.data.success) {
          setConversations(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch conversations", err);
      } finally {
        setLoading(false);
      }
    };

    fetchConversations();
  }, []);

  const handleConversationClick = (conv) => {
    if (conv.bookingId) {
      navigate(`/bookingChat/${conv.bookingId}`);
    } else if (conv.quoteId) {
      navigate(`/chat/${conv.quoteId}`);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const now = new Date();
    const msgDate = new Date(date);
    const diff = now - msgDate;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (days === 0) {
      return msgDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    } else if (days === 1) {
      return "Yesterday";
    } else if (days < 7) {
      return msgDate.toLocaleDateString([], { weekday: "short" });
    }
    return msgDate.toLocaleDateString([], { day: "2-digit", month: "short" });
  };

  if (loading) return <Loader />;

  return (
    <div className="inbox-wrapper">
      <div className="inbox-header">
        <button className="inbox-back-btn" onClick={() => navigate("/myProfile")}>
          <TfiArrowCircleLeft />
        </button>
        <h1>Messages</h1>
        <div className="header-actions">
          <FaUserCircle className="user-icon" />
        </div>
      </div>

      <div className="inbox-container">
        {conversations.length === 0 ? (
          <div className="empty-inbox">
            <img src="/asset/Logo/brownLogo.png" alt="No Messages" />
            <h3>No conversations yet</h3>
            <p>Start a chat by requesting a quote or booking a service.</p>
          </div>
        ) : (
          <div className="conversation-list">
            {conversations.map((conv) => {
              const lastMsg = conv.lastMessage || {};
              const isUnread = lastMsg.receiverId === currentUserId && !lastMsg.isRead;
              
              return (
                <div 
                  key={conv._id} 
                  className={`conversation-item ${isUnread ? "unread" : ""}`}
                  onClick={() => handleConversationClick(conv)}
                >
                  <div className="conv-avatar">
                    <img src="/asset/Logo/brownLogo.png" alt="Admin" />
                  </div>
                  <div className="conv-details">
                    <div className="conv-top">
                      <span className="conv-name">Veroa Admin</span>
                      <span className="conv-time">{formatDate(lastMsg.createdAt)}</span>
                    </div>
                    <div className="conv-bottom">
                      <p className="conv-last-msg">
                        {lastMsg.messageType === "paymentCard" ? "Sent a proposal" : lastMsg.message || "No messages yet"}
                      </p>
                      {isUnread && <span className="unread-dot"></span>}
                    </div>
                    <div className="conv-meta">
                        <span className="conv-type">
                            {conv.bookingId ? "Booking Chat" : "Quote Chat"}
                        </span>
                        <span className="conv-id">
                            #{conv.bookingId || conv.quoteId}
                        </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatInbox;
